import React from 'react'
import { FormViewProps } from './types'
import ClayLayout from '@clayui/layout';
import './FormViewStyled.css';

import { BASIC_INFORMATION_FIELDS } from '../../../utils/shortFormConfig';
import FormComponent from '../../../generic-components/formComponent/FormComponent';
import CutButton from '../../../generic-components/customCutButton/CutButton';

const FormView: React.FC<FormViewProps> = ({
    onSubmit,
    formMethods,
    isSubmitting,
    dropdownOptions,
    businessInformationFields,
    fileHandling
}) => {
    const {
        control,
        register,
        handleSubmit,
        watch,
        setError,
        clearErrors,
        formState: { errors }
    } = formMethods;

    return (
        <div className="create-event">
            <form
                onSubmit={handleSubmit(onSubmit)}
                className="create-event-form contact_form"
            >
                <div className="card-body">
                    <h1 className="event-details-heading create-event-heading px-0 m-0">
                        Basic Information
                    </h1>
                    <div className="partner-large-hr" />

                    <div className="pt-2">
                        <ClayLayout.Row className="content-gap">
                            {BASIC_INFORMATION_FIELDS.map((field: any) => (
                                <ClayLayout.Col
                                    key={field.name}
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    sm={12}
                                >
                                    <FormComponent
                                        label={field.label}
                                        name={field.name}
                                        placeholder={field.placeholder}
                                        component={field.component as any}
                                        register={register}
                                        control={control}
                                        errors={errors}
                                        watch={watch}
                                        setError={setError}
                                        required={field.required}
                                        options={dropdownOptions[field.name]}
                                        type={field.type}
                                        clearErrors={clearErrors}
                                        errorTitle={field.errorMessage}
                                        disabled={field?.disabled || false}
                                        selectedFiles={
                                            fileHandling[
                                                field.name as keyof typeof fileHandling
                                            ]?.selectedFiles
                                        }
                                        setSelectedFiles={
                                            fileHandling[
                                                field.name as keyof typeof fileHandling
                                            ]?.setSelectedFiles
                                        }
                                    />
                                </ClayLayout.Col>
                            ))}
                        </ClayLayout.Row>
                    </div>
                </div>

                {/* Event Logistics */}
                <div className="card-body">
                    <h1 className="event-details-heading create-event-heading px-0 m-0">
                        Business Information
                    </h1>

                    <div className="partner-large-hr mt-4" />

                    <div className="pt-2">
                        <ClayLayout.Row className="content-gap">
                            {businessInformationFields.map((field: any) => (
                                <ClayLayout.Col
                                    key={field.name}
                                    xl={6}
                                    lg={6}
                                    md={12}
                                    sm={12}
                                >
                                    <FormComponent
                                        label={field.label}
                                        name={field.name}
                                        placeholder={field.placeholder}
                                        component={field.component as any}
                                        register={register}
                                        control={control}
                                        errors={errors}
                                        watch={watch}
                                        setError={setError}
                                        required={field.required}
                                        type={field.type}
                                        disabled={false}
                                        clearErrors={clearErrors}
                                        options={dropdownOptions[field.name]}
                                        errorTitle={field.errorMessage}
                                    />
                                </ClayLayout.Col>
                            ))}
                        </ClayLayout.Row>
                    </div>

                    {/* Action Buttons */}
                    <ClayLayout.ContentSection className="button-group-container">
                        <CutButton
                            title={isSubmitting ? 'Submitting...' : 'Submit'}
                            buttonType="submit"
                            disabled={isSubmitting}
                        />
                    </ClayLayout.ContentSection>
                </div>
            </form>
        </div>
    );
};

export default FormView